import React, { Component } from "react";
import styled from "styled-components";
import Icon from "./Icon";
import XIcon from "../assets/CloseChat.png";

export default class CloseToolbar extends Component {
    render() {
        return (
            <XIconWrapper onClick={this.props.onClose} style={this.props.style ? {...this.props.style} : {}}>
                <Icon image={XIcon} isSmall={true} />
            </XIconWrapper>
        )
    }
}


const XIconWrapper = styled.div`
  display: flex;
  align-self: center;
  align-content: center;
  margin-right: 17px;
  width: 13px;
  height: 13px;
  cursor: pointer;
`;